import React from 'react'
import { connect } from 'react-redux'
import { Grid, Hidden } from '@material-ui/core'
import RightDrawer from './RightDrawer'
import PreviewView from './Main/PreviewView'
import MobileForm from './MobileForm'
import Snackbar from './Snackbar'
import RSC from 'react-scrollbars-custom'
import CustomIntegrationPreview from './Main/CustomIntegrationPreview'

const Build = ({ formTypeSelected }) => {
  if (!formTypeSelected) {
    return <div>Please select a form type</div>
  }

  return (
    <div style={{ height: '100%' }}>
      <Hidden smDown>
        <Grid
          style={{ height: '100%', justifyContent: 'center' }}
          container
          spacing={24}
        >
          <Grid style={{ height: '100%', maxWidth: 914.1 }} item xs={8}>
            {formTypeSelected === 'customIntegration' ? (
              <CustomIntegrationPreview />
            ) : (
              <RSC style={{ height: '100%', paddingRight: 5 }} noScrollX={true}>
                <PreviewView />
              </RSC>
            )}
          </Grid>
          <Grid style={{ height: '100%' }} item xs={4}>
            <RSC style={{ height: '100%', paddingRight: 5 }}>
              <RightDrawer formTypeSelected={formTypeSelected} />
            </RSC>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <MobileForm />
      </Hidden>
      <Snackbar />
    </div>
  )
}

export default connect(
	(state) => ({
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
	}),
	null,
)(Build)
